module.exports = __webpack_public_path__ + "img/register-dog.32058add.png";